<template>
  <div v-if="!$route.query.hShow"
    :style="backgroundImageAndlogo.headerBgColor ? { background: backgroundImageAndlogo.headerBgColor, border: '0px' } : ''"
    class="sidebar-logo-container" :class="{ 'collapse': collapse }">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <img v-if="!backgroundImageAndlogo.logo && ($i18n.locale === 'zh-CN' || $i18n.locale === 'zh-HK')" src="@/assets/logo.png" class="sidebar-logo">
        <img v-else-if="!backgroundImageAndlogo.logo" style="width: 122px" src="@/assets/logo.svg" class="sidebar-logo">
        
        <img v-if="backgroundImageAndlogo.logo" style="height: 44px;width: auto;" :src="backgroundImageAndlogo.logo" class="sidebar-logo"></img>
        <!--        <h1 v-else class="sidebar-title">{{ title }} </h1>-->
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="!backgroundImageAndlogo.logo && ($i18n.locale === 'zh-CN' || $i18n.locale === 'zh-HK')" src="@/assets/logo.png" class="sidebar-logo">
        <img v-else-if="!backgroundImageAndlogo.logo" style="width: 122px" src="@/assets/logo.svg" class="sidebar-logo">

        <img v-if="backgroundImageAndlogo.logo" style="height: 44px;width: auto;" :src="backgroundImageAndlogo.logo" class="sidebar-logo"></img>
        <!--        <h1 class="sidebar-title">{{ title }} </h1>-->
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    title() {
      return this.$store.getters.appName;
    },
    backgroundImageAndlogo() {
      console.log(this.$store.state.app.currentColorLogo)
      return this.$store.state.app.currentColorLogo
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: $sideBarWidth;
  height: 58px;
  // padding-top: 8px;
  background: #2c3b4e;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    & .sidebar-logo {
      width: 86px;
      vertical-align: middle;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
